import { EntityStatusState } from '@/store/root/root-store.model'
import { SimpleListResponse } from '@/api/services/common/simple-list/common-simple-list.dto'
import { TextNormalization } from '@/shared/util/text-normalization'

export class VtGridTextFormatter {
    static entityStatusStateFormatter(from: string, states: EntityStatusState[]): string {
        const state = states.find(s => s.code === from)
        return TextNormalization.removeDiacritics(state?.name ?? from)
    }

    static entitySimpleListFormatter(from: any, list: SimpleListResponse[]): string {
        if (!isNaN(from)) {
            const item = list.find(i => i.id === from)
            if (item) {
                return item.label.toUpperCase()
            }
        }
        return from.toUpperCase()
    }
}
